module.exports = __webpack_public_path__ + "img/loginbanner.6f028bc.jpg";